/**
 * before to publish:
 * 1-check the mode!
 * 2-check the endpoint!
 * 
 * mode production:  publish = true;      userTest = false;
 * mode test:        publish = true;      userTest = true;
 * mode development: publish = false ;    userTest = true;
 */

var publish = true;
var userTest = false;
var endpoint = 'production';
//production publish on pre-production domain to be tested before production
const preprod = false;

export const Config = {
  name: 'websci',
  version: require('../package.json').version,
  hostUrlApiSki: 'https://api-ski.mypass.technology/',
  hostUrlApiSkiTest: 'https://api-ski-test.mypass.technology/',
  //endpoint: endpoint,
  merchantURL: userTest ? 'https://user-test.mypass.ski/proxy.php?csurl=https://services.mypass.technology/sella/merchant_2.php' : 'https://user.mypass.ski/proxy.php?csurl=https://services.mypass.technology/sella/merchant_2.php',
  //https://user-test.mypass.ski/merchant_mypass_sci_2_web.html
  test:preprod? '0': endpoint == "production" ? "0" : "1",	// 1 -> test, 0 -> production version
  publish: publish, // true -> publishment, false -> development & debugging
  userTest: userTest,
  preprod: preprod,
  hostUrl:
    preprod ? 'https://user-preprod.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/' :
      publish ?
        endpoint == "production" ?
          (userTest ? 'https://user-test.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/' : 'https://user.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI/v1/') :
          (userTest ? 'https://user-test.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI.test/sci/' : 'https://user.mypass.ski/proxy.php?csurl=https://services.mypass.technology/MPLumenAPI.test/sci/')
        :
        'https://services.mypass.technology/MPLumenAPI.test/sci/',

  preferredCountry: 'it',
  platform: 'web',
  portal: 'sci',
  bank: {
    test:preprod? "0": endpoint == "production" ? "0" : "1",
    portal: 'sci',
    shopLogin:preprod? "9095024":  endpoint == "production" ? '9095024' : 'GESPAY65084',
  },

  // App download / DIY smart-link configuration. The actual smart link is
  // returned by `POST /links/click` (host derived from the API base, so
  // test and prod work transparently). These store URLs are only used as
  // an offline fallback when the click endpoint is unreachable.
  iosAppStoreUrl: 'https://apps.apple.com/it/app/mypassci/id1444908864',
  androidPlayStoreUrl: 'https://play.google.com/store/apps/details?id=com.mypassci',
};

export const ApiSkiConfig = {
  apiSkiUrl: Config.test == 0 ? Config.hostUrlApiSki : Config.hostUrlApiSkiTest,
}

export const firebaseConfig_test = {
  apiKey: "AIzaSyDpYMev34m6j75cxchBpFBANLhwQxw4wr4",
  authDomain: "mypassci-b69d9.firebaseapp.com",
  databaseURL: "https://mypassci-b69d9.firebaseio.com",
  projectId: "mypassci-b69d9",
  storageBucket: "mypassci-b69d9.firebasestorage.app",
  messagingSenderId: "438281859588",
  appId: "1:438281859588:web:47bc286121d00f5615fb51",
  measurementId: "G-Y9XR157DM8"
};
export const firebaseConfig = {
  apiKey: "AIzaSyDpYMev34m6j75cxchBpFBANLhwQxw4wr4",
  authDomain: "mypassci-b69d9.firebaseapp.com",
  databaseURL: "https://mypassci-b69d9.firebaseio.com",
  projectId: "mypassci-b69d9",
  storageBucket: "mypassci-b69d9.firebasestorage.app",
  messagingSenderId: "438281859588",
  appId: "1:438281859588:web:47bc286121d00f5615fb51",
  measurementId: "G-Y9XR157DM8"
};



// WEBPACK FOOTER //
// ./src/Config.js